/**
 * Pass-through wrappers for browser `window` APIs that tests need to control.
 *
 * jsdom defines `window`, `window.location`, and `location.href` as non-configurable properties. When Vitest runs
 * tests inside jsdom's own window (the `vmThreads` and `vmForks` pools), `vi.stubGlobal`, `Object.defineProperty`,
 * and `delete window.location` all throw, so tests cannot observe or prevent a navigation directly. Code that calls
 * the browser through this object gives tests a seam instead: `vi.mock('builder/WindowAdapter')` replaces every
 * method with a mock.
 *
 * Keep each method a one-line pass-through to the browser. Logic belongs in the caller, where mocked tests reach it.
 */
export const WindowAdapter = {
    /** Sends the browser to `url` with a full page load. */
    setLocation(url: string): void {
        window.location.href = url;
    },
};
